export default "__VITE_PUBLIC_ASSET__e2c6c219__"